






import { Component, Vue, Prop} from "vue-property-decorator";

@Component({})

export default class ArrowIcon extends Vue {
  /* Props */
  @Prop({ default: "#FFFFFF" })
  public color!: string;
}
